<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/overview">Solutions</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Products Line
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8 p-2 ">
              <h2 class="title">Products Line</h2>
              <p class="lead">
                Universal Tech LLC is a one-stop multi-vendor provider of data
                center hardware and equipment across all major IT brands.
                Besides offering a wide range of servers, storage, and
                networking products, Universal Tech LLC provides clients with
                the flexibility to sell and consign data center equipment to us
                via asset trade-in and buy-back programs. This eliminates the
                cost of storing their excess or end-of-life assets, optimizing
                the value of their enterprise equipment. Whether it is new
                resale, pre-owned, or end-of-life hardware, Universal Tech LLC
                is a vendor- agnostic provider of cost-efficient, quality
                hardware solutions all around the world. 
              </p>
              <p class="lead">We offer options to
                rent servers, storage, and networking equipment from one-week to
                one-year. We also buy-back old equipment so clients can use the
                funds towards new IT projects and initiatives.
              </p>
            </div>

            <div class="col-lg-4">
                <OverviewSideNav></OverviewSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import OverviewSideNav from "./OverviewSideNav";
export default {
  name: "productsline",
  components : {
    OverviewSideNav
  }
};
</script>

<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
